
import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { HelperService, AppSettings, AuthenticationService, Agents } from '../../../services/_services';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import Swal from 'sweetalert2';

declare var document, $;

@Component({
  selector: 'app-manage-team',
  templateUrl: './manage-team.component.html',
  styleUrls: ['./manage-team.component.css']
})
export class ManageTeamComponent implements OnInit {

  public teamStatus         : any = [
                                      { name: 'Active', value: 1 },
                                      { name: 'Block',  value: 0 },
                                    ];
  public agentTypes         : any = [
                                      { name: 'Special', value: 1 },
                                      { name: 'Normal',  value: 0 },
                                    ];
  public documentTypeArray  : any = AppSettings.documentType;
  public despositionArray   : any = AppSettings.disposition;
  public loading            : any = false;
  public paginatePage       : any;
  public leads              : any = [];
  public deletingLead_Index : any = null;
  public comments           : any = [];
  public agentComments      : any = [];
  public qaComments         : any = [];
  public agentsSub          : any;
  public departments        : any;
  public regions            : any;
  public teams              : any;
  public agents             : any;
  public qa                 : any;
  public loader             : any;


  @ViewChild(DataTableDirective)
  public dtElement    : DataTableDirective;
  public dtOptions    : DataTables.Settings = {};
  public dtTrigger    : any = new Subject();

  public searchParams            : any = { nameEmail : '', cat: null, team_id: null, status: 1 };
  public fullRangeDate           : any;
  public selectedDesposition     : any;

  constructor(
    private helperService     : HelperService,
    private agentsService     : Agents,
    private cdr               : ChangeDetectorRef,
  ) {

    // Get Agents
    this.agentsSub = this.agentsService.agentsS$.subscribe(agents => {
      if (agents) {
        this.departments = agents.departments;
        this.regions     = agents.regions;
        this.teams       = agents.teams;
        this.agents      = agents.agents;
        this.qa          = agents.qa;
      }
    });

    this.dtOptions = {
      paging: true,
      info: true,
      // ordering: false,
      pagingType: 'full_numbers',
      pageLength: 25,
      serverSide: true,
      processing: true,
      searching: false,
      'language': AppSettings.dataTableLang,
      "columnDefs": [
        { "orderable": false,                           "targets": 0 },
        { "orderable": false,                           "targets": 1 },
        { "orderable": false,                           "targets": 2 },
        { "orderable": false,                           "targets": 3 },
        { "orderable": false,                           "targets": 4 },
        { "orderable": false,                           "targets": 5 },
        { "orderable": false,                           "targets": 6 },
        { "orderable": false,                           "targets": 7 },
        { "orderable": false,                           "targets": 8 },
        { "orderable": false,                           "targets": 9 },
        { "orderable": false,                           "targets": 10 },
        { "orderable": false,                           "targets": 11 },
        { "orderable": false,                           "targets": 12 },
        { "orderable": false,                           "targets": 13 },
      ],
        "order": [[ 0, "ASC" ]],
        ajax: (dataTablesParameters: any, callback) => {
          // Show Loader
          this.loading = true;
          // console.log("dataTablesParameters", dataTablesParameters);

          let url  = AppSettings.API_ENDPOINT + 'admin/get-manage-team';

          let dtParams = {
                          nameEmail         : this.searchParams.nameEmail,
                          cat               : this.searchParams.cat,
                          team_id           : this.searchParams.team_id,
                          status            : this.searchParams.status,
                          start             : dataTablesParameters.start,
                          length            : dataTablesParameters.length,
                          order             : dataTablesParameters.order,
                          columns           : dataTablesParameters.columns
                        };

          // For Record Serial Numbers
          this.paginatePage = dataTablesParameters.start;

          // Reset Data
          this.leads.data = [];

          this.helperService.httpPostRequestsDecryp(url, dtParams)
            .then( resp => {
                this.leads        = JSON.parse(resp);

                // console.log("this.leads", this.leads);

                // Set Default page len
                this.dtOptions.pageLength = this.dtElement['dt'].page.len();

                // Hide Loader
                this.loading = false;

                callback({
                  recordsTotal: this.leads.total,
                  recordsFiltered: this.leads.total,
                  // recordsFiltered: resp['recordsFiltered'],
                  // recordsFiltered: 1000,
                  data: []
                });

                // // $(".paginate_button .current").css("color", "white");
                // // console.log('$(".paginate_button .current"): ',$(".paginate_button .current"))
                $('div.dataTables_length select').addClass('dt-form-control');
                $('div.dataTables_filter input').addClass('dt-form-control');
            })
            .catch(error => {
                // Set loader false
                this.loading = false;

                // // Rerender DT in case of failure
                // this.rerender();

                console.log("error: ",error);
            });
        },
        columns: [
          // { data: 'multiDelete' },
          { data: 'name' },
          { data: 'email' },
          { data: 'department' },
          { data: 'page_price' },
          { data: 'orders_allowed' },
          { data: 'emergency_contact' },
          { data: 'is_secure' },
          { data: 'phone' },
          { data: 'region' },
          { data: 'status' },
          { data: 'password' },
          { data: 'security' },
          { data: 'is_special' },
          { data: 'action' },
        ],
        // Use this attribute to enable the responsive extension
        responsive: false
      }

  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();

    if (typeof this.agentsSub != 'undefined') {
      //prevent memory leak when component destroyed
      this.agentsSub.unsubscribe();
    }
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      // Destroy the table first
      dtInstance.destroy();

      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  togglePass(index) {
    this.leads.data[index].showPass = !this.leads.data[index].showPass;
  }

  updateStatus(lead, index) {

    // Show Status Loader
    this.leads.data[index].updatingStatus = true;

    let url = AppSettings.API_ENDPOINT + "admin/update-agent-status";
    let data = { id: lead.id, status: lead.status };
    // console.log("data", data);

    this.helperService.httpPostRequests(url, data).then(resp => {
      if(typeof resp != "undefined" && resp.status == "OK") {
        // Swal.fire('', resp.message, 'success');
        // Show Status updated
        this.leads.data[index].updatedDone = true;
        setTimeout(() => {
          this.leads.data[index].updatedDone = false;
        }, 1000);
      }
      if(typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }

      // Hide Status Loader
      this.leads.data[index].updatingStatus = false;

    });
  }

  resetSecurity(lead, index) {
    // Show Status Loader
    this.leads.data[index].resetingSecurity = true;

    let url = AppSettings.API_ENDPOINT + "admin/reset-portal";
    let data = { id: lead.id };

    this.helperService.httpPostRequests(url, data).then(resp => {
      if(typeof resp != "undefined" && resp.message == "Portal has been reset.") {
        // Swal.fire('', resp.message, 'success');
        this.leads.data[index].resetSecurityUpdated = true;
        setTimeout(() => {
          this.leads.data[index].resetSecurityUpdated = false;
        }, 1000);
      }
      if(typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }

      // Hide Status Loader
      this.leads.data[index].resetingSecurity = false;
    });
  }

  updateAgentType(lead, index) {
    // Show Status Loader
    this.leads.data[index].updatingType = true;

    let url = AppSettings.API_ENDPOINT + "admin/update-agent-type";
    let data = { id: lead.id, is_special: lead.is_special };

    this.helperService.httpPostRequests(url, data).then(resp => {
      if(typeof resp != "undefined" && resp.status == "OK") {
        // Swal.fire('', resp.message, 'success');
        this.leads.data[index].agentUpdated = true;
        setTimeout(() => {
          this.leads.data[index].agentUpdated = false;
        }, 1000);
      }
      if(typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }

      // Hide Status Loader
      this.leads.data[index].updatingType = false;
    });
  }

  openDeleteModal(index) {
    this.deletingLead_Index = index;

    // Open Modal
    ($("#delete_modal"+index) as any).modal('show');
    $(".modal-backdrop").click(function(){
        $("#delete_modal"+index).modal("hide");
    });
  }

  delete_modal() {
    // Hide Modal
    ($('#delete_modal' + this.deletingLead_Index) as any).modal('hide');

    this.cdr.detectChanges();

    // Show Status Loader
    this.leads.data[this.deletingLead_Index].deletingAgent = true;

    let url = AppSettings.API_ENDPOINT + "admin/delete-agent";
    let data = { id: this.leads.data[this.deletingLead_Index].id, is_special: this.leads.data[this.deletingLead_Index].is_special };

    this.helperService.httpPostRequests(url, data).then(resp => {
      if(typeof resp != "undefined" && resp.status == "OK") {
        // Remove the Agent
        this.leads.data.splice(this.deletingLead_Index, 1);
        Swal.fire('', resp.message, 'success');
      }
      if(typeof resp != "undefined" && resp.status == "ERROR") {
        Swal.fire('', resp.message, 'error');
      }

      // Hide Status Loader
      this.leads.data[this.deletingLead_Index].deletingAgent = false;
    });
  }

  departmentSearch(id) {
    if (this.departments) {
        for (var i = 0; i < this.departments.length; i++) {
          if (this.departments[i].id === id) {
            return this.departments[i].name;
          }
        }
    }
  }

  agentSearch(id, agentArr) {
    for (var i = 0; i < agentArr.length; i++) {
      if (agentArr[i].id === id) {
        return agentArr[i].name;
      }
    }
  }

  clearFilters(){
    this.searchParams = { nameEmail: '', cat: null, team_id: null, status: 1 };
    this.rerender();
  }

}
